/**
 * Border-radius scale. Three steps plus pill — anything else is off-scale.
 *   sm: dense controls (chips, small inputs)
 *   md: the default (buttons, cards, inputs) — theme.shape.borderRadius
 *   lg: dialogs and prominent surfaces
 */
export const radius = {
  sm: 4,
  md: 8,
  lg: 12,
  pill: 999,
} as const;
